import React, { useEffect, useState } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';

export default function AdminFeedback() {
  const [dark, setDark] = useState(true);
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchFeedbacks = async () => {
      setLoading(true);
      try {
        const res = await fetch('https://api.mogym.ir/api/admin/feedback', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('admin_token')}`
          }
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.Message);
        setFeedbacks(data.Result || []);
      } catch {
        setError('خطا در دریافت فیدبک‌ها.');
      }
      setLoading(false);
    };

    fetchFeedbacks();
  }, []);

  const typeLabel = (type) => {
    switch (type) {
      case 1:
        return 'مشکل در برنامه تمرینی';
      case 2:
        return 'مشکل در برنامه غذایی';
              case 3:
        return 'برنامه مناسب نیست'
              case 4:
        return 'سایر';
      default:
        return 'نامشخص';
    }
  };

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white px-4 py-10 font-vazir">
        <div className="max-w-4xl mx-auto space-y-6">
          <h1 className="text-2xl font-bold text-center mb-6">مدیریت فیدبک کاربران</h1>

          {loading && <p className="text-center">در حال بارگذاری...</p>}
          {error && <p className="text-red-500 text-center">{error}</p>}

          <div className="space-y-4">
            {feedbacks.map((item, idx) => (
              <div
                key={idx}
                className="bg-gray-50 dark:bg-[#1c1f2b] p-4 rounded-xl shadow"
              >
                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm text-gray-700 dark:text-gray-300">
                    📱 {item.Phone}
                  </span>
                  <span className="text-xs bg-blue-100 dark:bg-blue-800 text-blue-700 dark:text-blue-300 px-3 py-1 rounded-full">
                    {typeLabel(item.Type)}
                  </span>
                </div>
                <p className="text-sm text-gray-500 dark:text-gray-400 mb-1">
                  ثبت در تاریخ: {new Date(item.CreatedAt).toLocaleDateString('fa-IR')}
                </p>
                <p className="text-sm">{item.Content}</p>
              </div>
            ))}
          </div>
        </div>

        {/* کلید تغییر تم */}
        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? '☀️' : '🌙'}
        </button>
      </div>
    </div>
  );
}
